import styled from 'styled-components';

import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { IconSelector } from '../../common/icons/cdl/Selector';
import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';

import { buildCollapsedEventsLabel } from './activityTimelineItems';
import { OfferChatMessage } from './types';

const COLLAPSED_MARKER_MASK_OFFSET = '2px';

const CollapsedButton = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    color: ${theme.colors.foreground.muted};
    column-gap: ${theme.space[8]};
    cursor: pointer;
    display: grid;
    grid-template-columns: 16px minmax(0, 1fr);
    height: 16px;
    margin: 0;
    padding: 0 0 0 16px;
    text-align: left;
    transition: color 100ms ease-out;
    width: 100%;

    &:hover {
        color: ${theme.colors.foreground.default};
    }
`;

const CollapsedMarkerMask = styled(Box)`
    &::before {
        content: '';
        position: absolute;
        top: -${COLLAPSED_MARKER_MASK_OFFSET};
        bottom: -${COLLAPSED_MARKER_MASK_OFFSET};
        left: 0;
        width: 16px;
        background: ${theme.colors.background.default};
        z-index: -1;
    }
`;

interface CollapsedSystemTimelineItemProps {
    messages: OfferChatMessage[];
    lineBefore: boolean;
    lineAfter: boolean;
    onShow: () => void;
}

export const CollapsedSystemTimelineItem = ({
    messages,
    lineBefore,
    lineAfter,
    onShow,
}: CollapsedSystemTimelineItemProps) => {
    const events = buildCollapsedEventsLabel(messages);
    const label = translate('activityLog.showEvents', {
        count: String(messages.length),
        events,
    });

    const showLine = lineBefore || lineAfter;

    return (
        <Box position="relative" paddingBottom={lineAfter ? 16 : 0}>
            {showLine ? (
                <Box
                    position="absolute"
                    top={lineBefore ? 0 : '16px'}
                    bottom={lineAfter ? 0 : '16px'}
                    left="24px"
                    width="1px"
                    style={{ transform: 'translateX(-50%)' }}
                    backgroundColor="border.muted"
                />
            ) : null}
            <CollapsedButton type="button" onClick={onShow}>
                <CollapsedMarkerMask
                    width="16px"
                    height="16px"
                    backgroundColor="background.default"
                    position="relative"
                    zIndex={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <IconSelector width={16} height={16} />
                </CollapsedMarkerMask>
                <Text
                    variant="extraSmall"
                    color="inherit"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {label}
                </Text>
            </CollapsedButton>
        </Box>
    );
};
